import { Outlet } from 'react-router-dom';
import { HeaderAuth } from '@/components/layout/Header/HeaderAuth';
import { HeaderPublic } from '@/components/layout/Header/HeaderPublic';
import { useAuth } from '@/contexts/AuthContext';

export function AuthLayout() {
  const { isAuthenticated } = useAuth();

  return (
    <div className="flex min-h-dvh flex-col bg-ink-50">
      {isAuthenticated ? <HeaderAuth /> : <HeaderPublic />}
      <main className="flex-1">
        <Outlet />
      </main>
    </div>
  );
}
